import { render } from "./AsidePCP.vue?vue&type=template&id=0f0ec02f&ts=true"
import script from "./AsidePCP.vue?vue&type=script&lang=ts"
export * from "./AsidePCP.vue?vue&type=script&lang=ts"

import "./AsidePCP.vue?vue&type=style&index=0&id=0f0ec02f&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__